var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DataAccess from "../../DataAccess";
export var Ptn;
(function (Ptn) {
    class ResultCategory {
        static tryGetResultCategories(trialID) {
            return __awaiter(this, void 0, void 0, function* () {
                let url = `TrialResultsCategory/trial-result-categories`;
                if (trialID) {
                    url += `?trialID=${trialID}`;
                }
                return yield DataAccess.getData(url);
            });
        }
        // process the return result and return an array of ResultCategoryModel from the response.data
        static GetResultCategories(trialID) {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.tryGetResultCategories(trialID);
                if (response && response.status === 200 && response.data) {
                    return response.data.map((item) => {
                        return {
                            id: item.id,
                            categoryName: item.categoryName,
                            categoryDescription: item.categoryDescription,
                        };
                    });
                }
                return [];
            });
        }
    }
    Ptn.ResultCategory = ResultCategory;
})(Ptn || (Ptn = {}));
